import { css } from '@emotion/react'
import { HFlow } from 'bold-ui'
import { useRovingTabIndex } from 'bold-ui/lib/hooks'
import { DropdownButton } from 'components/dropdown'
import React from 'react'

export interface MenuAcoesAgendamentoProps {
  children: React.ReactNode
}

export default function MenuAcoesAgendamento({ children }: MenuAcoesAgendamentoProps) {
  const rootRef = useRovingTabIndex({
    getItems: (root) => Array.from(root.querySelectorAll('button')),
  })

  const withoutDropdown = []
  const withDropdown = []

  React.Children.forEach(children, (child: React.ReactNode) => {
    if (React.isValidElement(child)) child.props.isDropdown ? withDropdown.push(child) : withoutDropdown.push(child)
  })

  return (
    <div ref={rootRef} data-testid='MenuAcoesAgendamento.button'>
      <HFlow
        hSpacing={0.5}
        alignItems='flex-start'
        style={css`
          height: 100%;
          padding-top: 0.25rem;
        `}
      >
        {withoutDropdown}
        {withDropdown.length > 0 && <DropdownButton>{withDropdown}</DropdownButton>}
      </HFlow>
    </div>
  )
}
